import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';
import { queryClient } from '@/lib/queryClient';

export const BOOTSTRAP_KEY = ['bootstrap'];

/** The app shell in one request.
 *  Every consumer shares this cache entry, so React Query collapses concurrent
 *  mounts (and StrictMode's double-invoke) into a single network call instead of
 *  the ~20 chrome requests each page used to fire. */
export function useBootstrap(enabled = true) {
  return useQuery({
    queryKey: BOOTSTRAP_KEY,
    queryFn: fetchBootstrap,
    staleTime: 60_000,
    gcTime: 900_000,
    refetchOnWindowFocus: true,
    retry: 0,
    enabled,
  });
}

export const fetchBootstrap = () => api.get('/bootstrap').then(r => r.data);

/** AuthProvider path: goes through the SAME query key so an in-flight shell
 *  request is shared with Layout instead of firing twice. */
export function loadBootstrap() {
  return queryClient.fetchQuery({
    queryKey: BOOTSTRAP_KEY,
    queryFn: fetchBootstrap,
    staleTime: 60_000,
  });
}

/** Seed the cache from AuthProvider's own bootstrap call so the shell renders
 *  without a second request. */
export function primeBootstrap(data) {
  if (data) queryClient.setQueryData(BOOTSTRAP_KEY, data);
}

export function invalidateBootstrap() {
  queryClient.invalidateQueries({ queryKey: BOOTSTRAP_KEY });
}
